import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PARTNER_UPDATE } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_invitations = (data) => {

    // var queryString = '';
    // if (data.status) {
    //     queryString = data.status.map((item) => `status=${item}`).join('&');
    // } else {
    //     queryString = `status=`
    // }
    // if (data.orderByProjectName) {
    //     queryString += queryString == '' ? `orderByProjectName=true` : `&orderByProjectName=true`;
    // }

    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            //return axios.get(`${Config.API_BASE_URL}/partner/invitations?${queryString}`, config)
            return axios.get(`${Config.API_BASE_URL}/partner/invitations`, config)
                .then(response => {
                    const payload = {
                        invitations: response.data,
                        errors: {},
                        task: {
                            result: true
                        }
                    }
                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: payload
                    })

                    return payload;
                })
                .catch(error => {
                    const payload = {
                        errors: {},
                        task: {
                            result: false
                        }
                    }

                    dispatch({
                        type: PARTNER_UPDATE,
                        payload: payload
                    })

                    return payload;
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_invitations;
